module.exports = __webpack_public_path__ + "static/WTP1-0111e46d087ba8d1d7529db8640a6a6c.jpg";